import React from "react";


const UserCellRenderer = (props:any)=>{
    //console.log(props);
    const onClickLink = ()=>{
        //console.log(props);
        props.editAction("editUser", props.data);
    }
    return(
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickLink} className={"cellRender"}>{props && props.value}</span></a>
        </div>

    )
}

export default UserCellRenderer;
